/**
 * Deliberately kept free of any three.js import.
 *
 * The section that decides whether to mount the globe needs this check, and
 * anything it imports gets pulled into the main bundle. Keeping the probe in
 * its own module is what keeps three.js in a lazy chunk.
 */
export function supportsWebGL() {
  if (typeof window === "undefined") return false;
  try {
    const canvas = document.createElement("canvas");
    return !!(
      window.WebGLRenderingContext &&
      (canvas.getContext("webgl2") || canvas.getContext("webgl"))
    );
  } catch {
    return false;
  }
}
